import React, { useState, useEffect } from "react";

import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Autocomplete,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  LinearProgress,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { IconButton, Tooltip, Chip } from "@mui/material";
import { useTasks, useTasksDispatch } from "../AppContext";
import { dispatchTYPE } from "../utils/constDispatch";

import { API_edit_booking } from "../utils/http";

function ListAccom({ accommondation, booking_id }) {
  const data_pdf = useTasks();
  const dispatch = useTasksDispatch();
  const [value_adding, setValueAdding] = useState(null);

  let list_accom_clean = [];
  let list_accom = new Set();

  try {
    if (data_pdf != null && accommondation != null) {
      data_pdf.activities.map((item) => {
        list_accom.add(item.accommondation.code);
      });

      for (const item_set of list_accom) {
        accommondation.map((item) => {
          if (
            item.code.toLowerCase().replace(/\W/g, "") ==
            item_set.toLowerCase().replace(/\W/g, "")
          ) {
            list_accom_clean.push(item);
          }
        });
      }
    }
  } catch (error) {
    console.log(error.message);
  }

  const headerRow = [
    { label: "CODE", id: 0, attr: "code", width: 10 },
    { label: "City", id: 1, attr: "city", width: 20 },
    { label: "Hotel", id: 2, attr: "hotel", width: 60 },
    { label: "Type", id: 3, attr: "type", width: 10 },
    { label: "Remark", id: 5, attr: "remark", width: 10 },
  ];

  if (accommondation == null) {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  } else {
    return (
      <Box style={{ marginTop: 10 }}>
        <Typography
          variant="h6"
          style={{ fontWeight: 600, marginBottom: 12 }}
        >
          Regenerated accommodation
        </Typography>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            borderRadius: "10px",
            border: "1px solid #E0E0E0",
            marginBottom: "12px",
          }}
        >
          <Table aria-label="simple table" size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#F5F7FA" }}>
                {headerRow.map((item) => (
                  <TableCell
                    key={item.id}
                    sx={{ fontWeight: 600, fontSize: 13, color: "#555" }}
                  >
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {list_accom_clean.map((row, idx) => (
                <TableRow
                  key={row.name || idx}
                  sx={{
                    "&:nth-of-type(even)": { backgroundColor: "#FAFAFA" },
                    "&:last-child td": { borderBottom: 0 },
                  }}
                >
                  {headerRow.map((rowx) => (
                    <TableCell key={rowx.id} sx={{ fontSize: 13 }}>
                      {row[rowx.attr]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography style={{ fontSize: 13, color: "#888", marginBottom: 12 }}>
          This list is based on location of Activities. If you click Regenerate,
          all accommodation will be replaced.
        </Typography>
        <Button
          size="small"
          variant="contained"
          endIcon={<SendIcon />}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 500,
            marginBottom: "20px",
          }}
          onClick={() => {
            dispatch({
              type: dispatchTYPE.accommondation_regenerate,
              value: list_accom_clean,
            });

            let data_body = {
              accommondation: list_accom_clean,
            };

            API_edit_booking(booking_id, data_body, (data) => {});
          }}
        >
          Regenerate
        </Button>

        <Divider />

        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            margin: "16px 0 12px 0",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            List of accommodation
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#9CA3AF" }}>
            · {data_pdf.accommondation.length}
          </Typography>
        </Box>

        {data_pdf.accommondation.map((item, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              marginBottom: "12px",
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#fff",
              overflow: "hidden",
              transition: "box-shadow 0.15s ease, border-color 0.15s ease",
              "&:hover": {
                borderColor: "#D1D5DB",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
                padding: "10px 14px",
                backgroundColor: "#F9FAFB",
                borderBottom: "1px solid #EEF0F2",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 24,
                    height: 24,
                    borderRadius: "6px",
                    backgroundColor: "#EEF2FF",
                    color: "#4F46E5",
                    fontSize: 12,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {index + 1}
                </Box>
                <Typography sx={{ fontWeight: 600, fontSize: 15, color: "#111827" }}>
                  {item.code}
                </Typography>
                {item.city ? (
                  <Chip
                    size="small"
                    icon={<PlaceOutlinedIcon sx={{ fontSize: 14 }} />}
                    label={item.city}
                    sx={{
                      height: 22,
                      fontSize: 12,
                      color: "#4B5563",
                      backgroundColor: "#F3F4F6",
                      "& .MuiChip-icon": { color: "#9CA3AF", marginLeft: "6px" },
                    }}
                  />
                ) : null}
              </Box>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  aria-label="Delete accommodation"
                  onClick={() => {
                    dispatch({
                      type: dispatchTYPE.accommondation_deleting,
                      index_in_array: index,
                    });
                  }}
                  sx={{
                    color: "#9CA3AF",
                    "&:hover": { color: "#DC2626", backgroundColor: "#FEF2F2" },
                  }}
                >
                  <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ padding: "14px", display: "flex", flexDirection: "column", gap: 1 }}>
              <TextField
                id="hotel"
                label="Hotel"
                multiline
                size="small"
                variant="outlined"
                defaultValue={"TBA"}
                value={item.hotel}
                onChange={(e) => {
                  dispatch({
                    type: dispatchTYPE.accommondation_hotel,
                    value: e.target.value,
                    index_in_array: index,
                  });
                }}
              />
              <TextField
                id="address"
                label="Address"
                multiline
                size="small"
                variant="outlined"
                defaultValue={"TBA"}
                value={item.address}
                onChange={(e) => {
                  dispatch({
                    type: dispatchTYPE.accommondation_address,
                    value: e.target.value,
                    index_in_array: index,
                  });
                }}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  sx={{ flex: 1 }}
                  id="type"
                  label="Type"
                  size="small"
                  variant="outlined"
                  defaultValue={"TBA"}
                  value={item.type}
                  onChange={(e) => {
                    dispatch({
                      type: dispatchTYPE.accommondation_type,
                      value: e.target.value,
                      index_in_array: index,
                    });
                  }}
                />
                <TextField
                  sx={{ flex: 1 }}
                  id="status"
                  label="Status"
                  size="small"
                  variant="outlined"
                  defaultValue={"TBA"}
                  value={item.status}
                  onChange={(e) => {
                    dispatch({
                      type: dispatchTYPE.accommondation_status,
                      value: e.target.value,
                      index_in_array: index,
                    });
                  }}
                />
                <TextField
                  sx={{ flex: 1 }}
                  id="remark"
                  label="Remark"
                  size="small"
                  variant="outlined"
                  defaultValue={"TBA"}
                  value={item.remark}
                  onChange={(e) => {
                    dispatch({
                      type: dispatchTYPE.accommondation_remark,
                      value: e.target.value,
                      index_in_array: index,
                    });
                  }}
                />
              </Box>
            </Box>
          </Paper>
        ))}

        <Typography
          variant="h6"
          style={{ fontWeight: 600, marginTop: 8, marginBottom: 8 }}
        >
          Adding accommodation
        </Typography>

        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          disableClearable
          id="combo-box-demo"
          options={accommondation}
          getOptionLabel={(option) => option.code}
          sx={{ width: 250, marginBottom: 1 }}
          size="small"
          onChange={(e, value) => {
            setValueAdding(value);
          }}
          renderInput={(params) => (
            <TextField {...params} label="CODE" value={params.code} />
          )}
        />

        {value_adding == null ? null : (
          <Button
            size="small"
            variant="outlined"
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 500,
              marginTop: 1,
            }}
            onClick={() => {
              dispatch({
                type: dispatchTYPE.accommondation_adding,
                value: accommondation[0],
              });
            }}
          >
            Add
          </Button>
        )}
      </Box>
    );
  }
}

export default ListAccom;
